(function (algolia) {
  "use strict";

  if (algolia.config.powered_by) {
    // eslint-disable-next-line no-console
    console.log(
      "You're using Algolia !\n" +
        "Visit https://www.algolia.com/ for more insight about what we do."
    );
  }

  /* Store variables */
  algolia.storeName = window.location.hostname
    .replace(/^www\./, "")
    .replace(/^([^.]*)\..*$/, "$1");

  algolia.templates = {};
  algolia.indices = {};

  /**
   * Checks whether we are on the `/search` page
   */
  algolia.full_results = Boolean(window.location.href.match(/\/search/));

  /**
   * Checks whether we are on a collection page
   */
  algolia.is_collection_results_page = Boolean(
    // We want to match `/collections/handle` but only if handle != 'all'
    window.location.pathname.match(/^\/collections\/(?!all$)([^/]+)[/]*$/)
    /**
     * To match /collections/handle/handle-two links as well, please use
     * the following regex instead:
     */
    // window.location.pathname.match(/^\/collections\/(?!all)(.*)$/)
  );

  /* Hide page content during InstantSearch loading */
  var collectionPageEnabled =
    algolia.is_collection_results_page &&
    algolia.config.instant_search_enabled_on_collection;
  var results_selector = collectionPageEnabled
    ? algolia.config.collection_css_selector
    : algolia.config.results_selector;
  results_selector += ", .algolia-shopify-instantsearch";

  if (
    (algolia.full_results && algolia.config.instant_search_enabled) ||
    collectionPageEnabled
  ) {
    algolia.contentHide = new DOMParser().parseFromString(
      "<style>" + results_selector + " { visibility: hidden }</style>",
      "text/html"
    ).head.firstElementChild;
    document.head.append(algolia.contentHide);
  }

  /* We use Hogan as our templating engine with a custom delimiter: [[ ... ]] */
  algolia.hoganOptions = { delimiters: "[[ ]]" };
  algolia.getTemplate = function getTemplate(name) {
    var el = document.getElementById("template_algolia_" + name);
    return el ? el.innerHTML : "";
  };
  algolia.compileTemplate = function compileHoganTemplate(name) {
    return algolia.externals.Hogan.compile(
      algolia.getTemplate(name),
      algolia.hoganOptions
    );
  };
  algolia.render = function render(template, obj) {
    var newObj = algolia.assign({}, obj, { helpers: algolia.hoganHelpers });
    return template.render(newObj);
  };

  // Current collection page ID
  var current_collection_id_string = algolia
    .getTemplate("current_collection_id")
    .replace(/^\s+|\s+$/g, "");

  if (current_collection_id_string) {
    try {
      var current_collection_id_object = JSON.parse(
        current_collection_id_string
      );
      algolia.current_collection_id =
        current_collection_id_object.currentCollectionID;
    } catch (error) {
      // Encountered an error while trying to parse the collection ID.
      // This most probably means that we aren't on a collection page.
    }
  }

  /* Add CSS block after current script */
  algolia.appendStyle = function appendStyle(content) {
    var scripts = document.getElementsByTagName("script");
    var currentScript = scripts[scripts.length - 1];
    var style = document.createElement("style");
    style.innerHTML = content;
    currentScript.parentNode.insertBefore(style, currentScript.nextSibling);
  };

  algolia.assign = function assign(to) {
    for (var i = 1; i < arguments.length; i++) {
      var nextSource = arguments[i];
      for (var nextKey in nextSource) {
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey]; // eslint-disable-line no-param-reassign
        }
      }
    }
    return to;
  };

  /* Here because we need to ensure we have a fallback with '$ '. */
  algolia.money_format = algolia
    .getTemplate("money_format")
    .replace(/^\s+|\s+$/g, "");
  algolia.formatMoney = function formatMoney(cents) {
    //var val = (cents / 100.0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    var centsVal = cents.toString();
    //console.log(centsVal);
    var moneyFilter = /\b(\d+)(\d{2})\b/;
    var moneyFilterSubst = "$1,$2";
    var val = centsVal.replace(moneyFilter, moneyFilterSubst);

    var format = algolia.money_format;

    if (format.includes("SFr. ")) {
      format = format.replace("SFr.", "CHF ");
    }
    /**
     * The following block adds support for Shopify multi currency and converts
     * prices from the store currency to the currency selected by the user (aka
     * "presentment" currency) Please note that this relies on the
     * `Shopify.currency` object exposed by Shopify which is an undocumented
     * feature and can break at any time.
     */
    if (Shopify && Shopify.currency && Shopify.currency.rate) {
      // Convert to "presentment" currency using the rate provided by Shopify

      val = Number(parseFloat(val).toFixed(2)); // convert val to float with two decimal places before doing currency conversion
      val = Number(parseFloat(val * Shopify.currency.rate).toFixed(2)); // Get converted value, with two decimals.
      // Custom round up code by Kvalifik.
      // The method for rounding each currency is determined by settings from Shopify payments.
      // Eg: By default, EUR is rounded to nearest .95, whereas GBP and USD is rounded to nearest 1.00
      // If changes are made to rounding in Shopify Payments, uou need to be manually edit below.

      var currencySymbol = "";
      switch (Shopify.currency.active) {
        case "EUR":
          currencySymbol = "€";
          break;
        case "GBP":
          currencySymbol = "£";
          break;
        case "USD":
          currencySymbol = "$";
          break;
        case "RUB":
          currencySymbol = "₽";
          break;
        case "JPY":
          currencySymbol = "¥";
          val = Math.round(val);
          break;
        case "CHF":
          currencySymbol = "CHF ";
          break;
        case "SEK":
          currencySymbol = "SEK";
          val = Math.round(val);
          break;
        case "NOK":
          currencySymbol = "NOK";
          break;
        case "DKK":
          currencySymbol = "DKK";
          break;
        default:
          currencySymbol = "";
      }

      // Convert back to string to allow formatting
      val = val.toString();
    }

    // Not necessary, but allows for more risk tolerance if Shopify.formatMoney doesn't work as we want
    var regexp = /^([^{}]*)\{\{amount\}\}([^{}]*)$/;
    if (format.match(regexp)) {
      return format.replace(regexp, "$1" + val + "$2");
    }

    if (!Shopify && !Shopify.formatMoney) {
      return Shopify.formatMoney(cents, format);
    }

    var formattedCurrency = currencySymbol + val;

    if (
      currencySymbol == "NOK" ||
      currencySymbol == "SEK" ||
      currencySymbol == "DKK"
    ) {
      formattedCurrency = val + " " + currencySymbol;
    }

    if (currencySymbol == "CHF") {
      formattedCurrency = "CHF " + val;
    }

    return formattedCurrency;
  };

  // Custom function by Kvalifik
  // Fetches current page, so we can conditionally render full-width embedded products
  algolia.getCurrentPage = () => {
    return document
      .querySelector(".ais-Pagination-item--selected .ais-Pagination-link")
      .getAttribute("aria-label");
  };

  // Custom function by Kvalifik
  // Checks if product has a custom data-colspan, and changes parent element accordingly.
  // Allows for varied grid item sizes, controlled by tag. data-colspan is set via Helper function in product item hogan, and this function is run whenever Instantsearch.Hits is rendered.
  algolia.resizeGridItems = () => {
    setTimeout(function () {
      // Timeout of 50ms allows DOM to be populated
      const products = [...document.getElementsByClassName("ais-InfiniteHits-item")];
      if (products) {
        for (let product of products) {
          let productCard = product.childNodes[0];

          if (productCard.dataset.colspan > 1) {
            if (productCard.dataset.colspan == 2) {
              product.classList.add("col-span-2");
            } else {
              product.classList.add("col-span-2");
              product.classList.add(
                "lg:col-span-" + productCard.dataset.colspan
              );
            }
          } else if (
            productCard.dataset.title.toLowerCase().includes("bundle")
          ) {
            product.classList.add("col-span-2"); // If no gridsize has been set, and product is a bundle, make it span 2 columns.
            productCard.dataset.colspan = 2;
          }
          // If Product should be embedded as a full page, add col-span-full and show embedded info
          // Disabled until embedded products are re-enabled
          /*
        if(productCard.dataset.embedproduct === "true"){
          product.classList.add("col-span-full");
          product.classList.add("ais-hit-embedded");
        }
        */
        }
      }
    }, 50);
  };

  algolia.initFacets = () => {
    let openFacets = document.getElementsByClassName("js-facet-open");
    Array.from(openFacets).forEach(function (facet) {
      let facetInner = facet.nextElementSibling;
      facetInner.style.maxHeight = facetInner.scrollHeight + "px";
    });
  };

  algolia.initShowMore = () => {
    let showMoreButtons = document.querySelectorAll(
      ".ais-RefinementList-showMore"
    );
    Array.from(showMoreButtons).forEach(function (showMoreButton) {
      showMoreButton.addEventListener("click", function () {
        let facetInner =
          showMoreButton.parentNode.parentNode.parentNode.parentNode.parentNode;
        facetInner.style.maxHeight = facetInner.scrollHeight + "px";
      });
    });
  };

  algolia.renderNextPageIndicator = () => {
    setTimeout(() => {
      // Timeout of 100ms so Algolia can calculate grid sizes and render items.
      const hasNextPageIndicator = document.querySelector(".ais-Hits-spacer");
      const isLastPage = document
        .querySelector(".ais-Pagination-item--nextPage")
        .classList.contains("ais-Pagination-item--disabled");
      const products = document.querySelectorAll(".ais-Hits-item");

      if (products.length > 0 && !isLastPage) {
        if (!hasNextPageIndicator) {
          // First render, create and append spacer element.
          const gridSpacerElem = document.createElement("li");
          gridSpacerElem.classList = "ais-Hits-spacer";
          const productGrid = document.querySelector(".ais-Hits-list");
          productGrid.appendChild(gridSpacerElem);
          populateSpacer();
        } else {
          populateSpacer();
        }
      }

      // If no products or lastPage, empty spacer element.
      if (isLastPage) {
        //console.info("Last page, removing spacer");
        document.querySelector(".ais-Hits-spacer").innerHTML = "";
      }
    }, 100);
  };

  const populateSpacer = () => {
    const gridSpacer = document.querySelector(".ais-Hits-spacer");

    // Fetch Algolia next page element
    const gridSpacerLink = document.querySelector(
      ".grid-spacer-container .grid-spacer-link .ais-Pagination-link"
    );

    if (gridSpacerLink) {
      // Get Spacer Size and classes
      // We calculate a new spacer size for each breakpoint, on every render, based on items in grid.
      const spacerSize = calculateSpacerSize();
      const spacerClasses = `ais-Hits-spacer flex items-end !border-none !w-full !h-full fade-in max-h-[700px] ${spacerSize}`;

      // Reset spacer
      gridSpacer.classList = spacerClasses;
      gridSpacer.innerHTML = "";

      // Move Algolia next page element into spacer

      gridSpacer.appendChild(gridSpacerLink);

      // Populate spacer with content from section
      gridSpacer.querySelector(".ais-Pagination-link").innerHTML =
        document.querySelector(".grid-spacer-content").innerHTML;
    }
  };

  const calculateSpacerSize = () => {
    /*
      Beer grid:
      >1536px: 7 cols
      >1280px: 6 cols
      >1024px: 5 cols
      >768px: 3 cols
      <768px: 2 cols
    */

    //const optimalGrid = window.algoliaShopify.config.products_full_results_hits_per_page;

    const items = document.querySelectorAll("[data-colspan]");
    let gridItemsSmall = 0;
    let gridItems = 0;
    for (let item of items) {
      let itemSpan = parseInt(item.getAttribute("data-colspan"));
      gridItems = gridItems + itemSpan;
      //console.info(`${item.getAttribute("data-handle")} is ${item.getAttribute("data-colspan")}, grid items is now: ${gridItems}`);
      if (itemSpan != 1) {
        gridItemsSmall = gridItemsSmall + 2;
      } else {
        gridItemsSmall = gridItemsSmall + itemSpan;
      }
    }

    // console.info(`On small devices there are ${gridItemsSmall} in grid`);
    // console.info(`On lg and up there are ${gridItems} in grid`);

    const gridSmall = 2;
    const gridMedium = 3;
    const gridLarge = 5;
    const gridXL = 6;
    const grid2XL = 7;

    const fullRowSmall = gridItemsSmall % gridSmall == 0 ? true : false;
    const spacerSmall = fullRowSmall
      ? `hidden`
      : `col-span-${gridSmall - (gridItemsSmall % gridSmall)}`;

    const fullRowMedium = gridItemsSmall % gridMedium == 0 ? true : false;
    const spacerMedium = fullRowMedium
      ? `md:hidden`
      : `md:block md:col-span-${gridMedium - (gridItemsSmall % gridMedium)}`;

    const fullRowLarge = gridItems % gridLarge == 0 ? true : false;
    const spacerLarge = fullRowLarge
      ? `lg:hidden`
      : `lg:block lg:col-span-${gridLarge - (gridItems % gridLarge)}`;

    const fullRowXL = gridItems % gridXL == 0 ? true : false;
    const spacerXL = fullRowXL
      ? `xl:hidden`
      : `xl:block xl:col-span-${gridXL - (gridItems % gridXL)}`;

    const fullRow2XL = gridItems % grid2XL == 0 ? true : false;
    const spacer2XL = fullRow2XL
      ? `2xl:hidden`
      : `2xl:block 2xl:col-span-${grid2XL - (gridItems % grid2XL)}`;

    // console.info(spacerSmall)
    // console.info(spacerMedium)
    // console.info(spacerLarge)
    // console.info(spacerXL)
    // console.info(spacer2XL)

    return (
      spacerSmall +
      " " +
      spacerMedium +
      " " +
      spacerLarge +
      " " +
      spacerXL +
      " " +
      spacer2XL
    );
  };
})(window.algoliaShopify);
